import axios from 'axios'
import router from './router'

const BACKEND_CONTEXT_PATH = '/api'
const DEFAULT_API_BASE = process.env.NODE_ENV === 'production' ? '/prod-api' : 'http://localhost:8090/api'
const API_BASE = process.env.VUE_APP_API_BASE || DEFAULT_API_BASE
const LOGIN_CODES = [401, 403]
export const MAX_UPLOAD_FILE_SIZE = 500 * 1024 * 1024
export const UPLOAD_TIMEOUT = 0

function joinUrl(base, path) {
  if (!base) return path
  if (!path) return base
  return `${String(base).replace(/\/+$/, '')}/${String(path).replace(/^\/+/, '')}`
}

function redirectToLogin() {
  localStorage.removeItem('ANTI_ADMIN_TOKEN')
  if (router.currentRoute.path !== '/login') {
    router.replace('/login')
  }
}

const http = axios.create({
  baseURL: API_BASE,
  timeout: 20000
})

http.interceptors.request.use(config => {
  const token = localStorage.getItem('ANTI_ADMIN_TOKEN')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(response => {
  const data = response.data
  if (data && Object.prototype.hasOwnProperty.call(data, 'code')) {
    if (data.code !== 0) {
      if (LOGIN_CODES.includes(data.code)) {
        redirectToLogin()
      }
      return Promise.reject(new Error(data.message || '请求失败'))
    }
    return data.data
  }
  return response
}, error => {
  if (error.response && LOGIN_CODES.includes(error.response.status)) {
    redirectToLogin()
  }
  return Promise.reject(error)
})

export const apiBase = API_BASE
export const downloadUrl = path => joinUrl(API_BASE, path)
export async function downloadFile(path, fallbackFilename = 'download') {
  const response = await http.get(path, { responseType: 'blob' })
  const contentType = response.headers && response.headers['content-type']

  if (contentType && contentType.includes('application/json')) {
    const text = await response.data.text()
    const data = JSON.parse(text)
    if (data && data.code !== 0) {
      if (LOGIN_CODES.includes(data.code)) {
        redirectToLogin()
      }
      throw new Error(data.message || '下载失败')
    }
  }

  const blob = response.data
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filenameFromDisposition(response.headers && response.headers['content-disposition'], fallbackFilename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

function filenameFromDisposition(disposition, fallbackFilename) {
  if (!disposition) return fallbackFilename
  const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i)
  const filename = match && (match[1] || match[2])
  if (!filename) return fallbackFilename
  try {
    return decodeURIComponent(filename.replace(/\+/g, '%20'))
  } catch (e) {
    return filename
  }
}

export const absoluteUrl = url => {
  if (!url) return ''
  if (/^https?:\/\//.test(url)) return url
  if (url.startsWith(BACKEND_CONTEXT_PATH + '/')) {
    return joinUrl(API_BASE, url.slice(BACKEND_CONTEXT_PATH.length))
  }
  return joinUrl(API_BASE, url)
}
export default http
